import script from "./NodePalette.vue?vue&type=script&setup=true&lang=js"
export * from "./NodePalette.vue?vue&type=script&setup=true&lang=js"

import "./NodePalette.vue?vue&type=style&index=0&id=78f445c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f445c6"]])

export default __exports__